  <template>
    <div>
      <loading v-show="showLoader" />

      <div class="ib-main-section">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <router-link class="ib-back-btn" :to="{ name: 'Claims' }">Back</router-link>
              <br>
              <h1 class="ib-claim-listing">{{ MajorClass }}</h1>
            </div>
          </div>
          <div class="d2c-class-container " style="position:relative; padding-bottom: 9px; margin-top: 20px;" v-if="nav_step_one">
              <ul role="tablist" class="nav nav-tabs ib-nav-tabs">
                <li class="nav-item" style="cursor: pointer" v-for="(claim_type, key) in claim_types" v-on:click="setType(claim_type.id, )" >
                  <a class="nav-link class-box" :class="selected_claim_type == claim_type.id ? 'active' : ''" style="margin-left: 0; margin-right: 1rem" :content="'Choose claim type'" v-tippy>
                    <img alt="icon" :src="claim_type.image">
                    <h4 class="class-name class-buy">{{ claim_type.text }}</h4>
                  </a>
                </li>
              </ul>
          </div>
        </div>

        <div class="container-fluid ib-acquisition-bg">
          <div class="container ib-p-0">
            <div class="container multistep-box listing-design-fixed">
              <div v-show="mainArea" class="row mb-4">
                <div class="container tab-content data-row" id="v-pills-tabContent" style="border: 0; box-shadow: none; background-color:transparent !important;">
                  <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="col-md-12">
                              <div class="listing-nav">
                                <div class="d2c-main-classes" id="nav-tab" inaddclaim="addclaimnav" role="tablist" style="overflow: scroll hidden;">
                                  <button class="d2c-class-btn" :class="(selectedClassId == major_class.id) ? 'active' : ''" v-for="(major_class, key) in major_classes" @click="LoadClaims(major_class)">
                                    <div class="in-right-border" style="text-transform: capitalize;">
                                      {{  major_class.name }}
                                    </div>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12" v-if="SubStep == false">
                          <table class="claim-listing">
                            <tbody>
                            <tr v-for="customer_claim in customer_claims" v-on:click="set_quotation_id(customer_claim.id, customer_claim.subclass_name,customer_claim)">
                              <!-- <td class="jbl-responsive-td data-img">
                                <img alt="icon" class="img-fluid" :src="customer_claim.product_image"/>
                                <div class="position-relative">
                                  <img alt="icon" class="img-fluid small-icon" :src="customer_claim.company_logo_path"/>
                                </div>
                              </td> -->
                              <td class="jbl-responsive-td data-img">
                                <div class="in-listing-img">
                                  <img class="img-fluid" :src="customer_claim.product_image"/>
                                  <div class="position-relative-box">
                                    <img alt="icon" class="img-fluid small-icon" :src="customer_claim.company_logo_path"/>
                                  </div>
                                </div>
                              </td>
                              <td class="jbl-table-heading jbl-responsive-td">{{ customer_claim.subclass_name }}&nbsp;<small style="color: var(--secondary-color);">{{ customer_claim.product_name }}</small></td>
                              <td class="jbl-responsive-td" v-if="customer_claim.policy_no != null">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">Policy No</div>
                                  <div class="jbl-date-td">{{ customer_claim.policy_no}}</div>
                                </div>
                              </td>
                              <td class="jbl-responsive-td"><router-link :to="{ name: 'ClaimsView', params: { id: customer_claim.id } }" class="nex-Page-Link"><i class="fa fa-chevron-right"></i></router-link></td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-md-12 d-none d-md-block" v-else>
                          <table class="claim-listing">
                            <tbody>
                            <tr v-for="(risk_listing,index) in risks" :key="index" @click="setRiskId(risk_listing.id)">
                              <td class="jbl-responsive-td data-img">
                                <div class="in-listing-img">
                                  <img alt="icon" class="img-fluid small-icon" :src="selectedPolicy.product_image" />
                                </div>
                              </td>
                              <td class="jbl-responsive-td">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">Risk ID:</div>
                                  <div class="jbl-date-td">{{ risk_listing.id}}</div>
                                </div>
                              </td>
                              <td class="jbl-responsive-td" v-if="risk_listing.form_data.stage_1[0].label !=''">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">{{ risk_listing.form_data.stage_1[0].label }}</div>
                                  <div class="jbl-date-td ib-td-currency"><span>{{risk_listing.form_data.stage_1[0].value}}</span></div>
                                </div>
                              </td>
                              <td class="jbl-responsive-td" v-if="risk_listing.form_data.stage_1[1].label !=''">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">{{ risk_listing.form_data.stage_1[1].label }}</div>
                                  <div class="jbl-date-td ib-td-currency"><span>{{risk_listing.form_data.stage_1[1].value}}</span></div>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                          <h2 style="color: rgba(0, 0, 0, 0.3) !important; text-align:center;" v-if="risks.length === 0">No Policy Found</h2>
                        </div>
                        <h2 v-if="customer_claims.length <= 0" style="color: rgb(201, 203, 205);">No Policy Found</h2>
                        <!--                      <div class="mt-5">-->
                        <!--                        <button class="ib-btn-primary ib-btn-width ib-btn-hover" v-if="Object.keys(claim_types).length !== 0" v-on:click="next_step(1)">CONTINUE</button>-->
                        <!--                      </div>-->
                      </div>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                    <div class="container">
                      <div class="in-subclass-bb" style="padding-bottom: 3rem" v-if="nav_step_one" >
                        <div class="col-md-12 text-center d-md-none">
                          <img v-if="nav_link == 0" class="img-fluid in-add-claim-img" :src="require('@/assets/images/claim-step-1.svg')">
                          <img v-if="nav_link == 1" class="img-fluid in-add-claim-img" :src="require('@/assets/images/claim-step-2.svg')">
                          <img v-if="nav_link == 2" class="img-fluid in-add-claim-img" :src="require('@/assets/images/claim-step-3.svg')">
                          <img v-if="nav_link == 3" class="img-fluid in-add-claim-img" :src="require('@/assets/images/claim-step-4.svg')">
                        </div>
                        <div class="col-md-12 d-none d-md-block text-center">
                          <img v-if="nav_link == 0" class="img-fluid" :src="require('@/assets/images/claim-step-1.svg')">
                          <img v-if="nav_link == 1" class="img-fluid" :src="require('@/assets/images/claim-step-2.svg')">
                          <img v-if="nav_link == 2" class="img-fluid" :src="require('@/assets/images/claim-step-3.svg')">
                          <img v-if="nav_link == 3" class="img-fluid" :src="require('@/assets/images/claim-step-4.svg')">
                        </div>
                        <div class="col-md-6" style="display: none">
                          <div class="nav d-flex nav-pills jbl-nav-tabs primary-color jbl-progressbar-container" id="v-pills-tab" role="tablist" aria-orientation="vertical" style="justify-content:center !important; position: relative; top: 2rem;">
                            <a style="pointer-events: none" class="nav-link nav-link-local jbl-progressbar-left nav-link-quotation active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true"><img id="step_1" :src="require('@/assets/images/claim-1-select.svg')"><img style="display: none" id="step_1_hover" :src="require('@/assets/images/claim-1-select.svg')"><span>Upload Information</span></a>
                            <a style="pointer-events: none" class="nav-link nav-link-local jbl-progressbar-left nav-link-quotation" id="v-pills-messages-tab" data-toggle="pill" href="#v-pills-messages" role="tab" aria-controls="v-pills-messages" aria-selected="false"><div class="jbl-progress-icon"><img id="step_3" :src="require('@/assets/images/claim-2.svg')"> <img style="display: none" id="step_3_hover" :src="require('@/assets/images/claim-2-select.svg')"><span>Claim Form</span></div></a>
                            <a style="pointer-events: none" class="nav-link nav-link-local jbl-progressbar-left nav-link-quotation" id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false"><div class="jbl-progress-icon"><img id="step_4" :src="require('@/assets/images/claim-3.svg')"> <img style="display: none" id="step_4_hover" :src="require('@/assets/images/claim-3-select.svg')"><span>Upload Info &amp; Documents</span></div></a>
                            <a style="pointer-events: none" class="nav-link nav-link-local jbl-progressbar-left nav-link-quotation" id="v-pills-upload-doc" data-toggle="pill" href="#v-pills-odc" role="tab" aria-controls="v-pills-settings" aria-selected="false"><div class="jbl-progress-icon"><img id="step_5" :src="require('@/assets/images/claim-4.svg')"> <img style="display: none" id="step_5_hover" :src="require('@/assets/images/claim-4-select.svg')"><span>Summary Detail</span></div></a>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <form id="custom_form">
                            <h2 class="upload-title">{{ tab_heading }}</h2>

                            <h2 class="documents-heading mb-3" v-if="nav_step_one">{{ form_name.replace(/_/g,' ') }}</h2>
                            <div v-if="nav_step_one" class="container px-0">
                              <div>
                                <div v-for="(section, index) in claimForm" :key="index" class="row">
                                  <div v-for="(field, index) in section.custom_fields" :key="index" :style="(typeform1 == false) ? {'display' : 'none'} : {'display' : 'block'}" class="col-md-6 px-0 px-sm-3">
                                      <div class="form-group" v-if="field.type == 'dropdown'">
                                        <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                                        <div class="floating-label">
                                          <select style="width: 100% !important;" class="floating-select" :name="field.field_name" onclick="this.setAttribute('value', this.value);" value="">
                                            <option v-for="(value, index) in field.default_values" :value="value.id" :key="index">{{value.text}}</option>
                                          </select>
                                          <span class="highlight"></span>
                                          <div class="ib-custom-select"></div>
                                        </div>
                                      </div>

                                      <div v-else-if="field.type == 'textBox'">
                                        <div class="jbl-field">
                                          <input :type="field.type" class="input-fields jbl-dynamic-input" :name="field.field_name" v-model="stepZeroDynamicField[field.field_name]"   :placeholder="'Enter '+ field.label">
                                        </div>
                                        <div v-if="stepZeroErrors.filter(x => x.field == field.field_name).length > 0">
                                          <div>
                                            <small class="text-danger">{{stepZeroErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                          </div>
                                        </div>
                                      </div>

                                      <div v-else-if="field.type == 'date'">
                                        <div class="jbl-field">
                                          <input :type="field.type" class="input-fields" :max="formatDate(field.max_date)" :min="formatDate(field.min_date)" :name="field.field_name"  :placeholder="'Enter ' + field.label">
                                        </div>
                                      </div>

                                      <div class="" v-else-if="field.type == 'checkbox'">
                                        <label class="jbl-checkbox-container" style="display: block !important;">{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}
                                          <input value="1" type="checkbox" :name="field.field_name">
                                          <span class="checkmark"></span>
                                        </label>
                                      </div>

                                      <div v-else-if="field.type == 'textArea'">
                                        <div class="jbl-field">
                                          <textarea class="input-fields jbl-dynamic-input"  :name="field.field_name" v-model="stepZeroDynamicField[field.field_name]"  :placeholder="'Enter ' + field.label"></textarea>
                                        </div>
                                        <div v-if="stepZeroErrors.filter(x => x.field == field.field_name).length > 0">
                                          <div>
                                            <small class="text-danger">{{stepZeroErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="col-md-12" v-else-if="field.type == 'radio'">
                                        <label class="jbl-radio-container" style="display: block !important;">{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}
                                          <input value="1" type="radio" :name="field.field_name">
                                          <span class="checkmark"></span>
                                        </label>
                                      </div>
                                      <div class="mt-5"></div>
                                    </div>
                                </div>
                              </div>
                            </div>

                            <div v-if="nav_step_two">
                              <div class="row" v-if="selectedSubclassname.toLowerCase().includes('cycle')">
                                <label class="" :for="'motor-cycle-img'" :class="MotorCycleImages.length < 1 ? '' : 'ib-generic-label'">
                                  <div class="w-100 text-center">
                                    <div class="second-upload-btn">
                                      <div class="jbl-browse-text">
                                        <div>
                                          <img :src="require('@/assets/images/upload-images.svg')" alt="">
                                        </div>
                                        <div>Upload Images </div>
                                      </div>
                                    </div>
                                  </div>
                                </label>
                                <input id="motor-cycle-img" style="display: none" type="file" multiple accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'frontRight')" class="css-checkbox">

                                <div class="col-md-3" v-for="(image, index) in MotorCycleImages" :key="image.name">
                                  <div class="document-list">
                                    <div class="">
                                      <span>
                                        <img class="doc-remove-icon doc-remove-icon2" @click="removestepThreeMotorImages(image, index)" :src="require('@/assets/images/ib-upload-remove-icon.svg')">
                                      </span>
                                    </div>
                                    <span class="document-list-title document-list-title2" style="height:100% !important;"><img class="img-fluid custom-w-m" :src="require('@/assets/images/text-document.svg')"> {{image.name}}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="row" v-else>
                                <div class="col-md-7 order-2 order-md-1 pt-4 pt-md-0">
                                  <div class="image-gallery">
                                    <div class="image-gallery-row">
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_frontRight" :src="stepThreeMotorImagesPath['frontRight']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'frontRight').length > 0" class="mt-3 pl-2">
                                          <div>
                                            <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'frontRight')[0].message}}</small>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview"  id="_frontCenter" :src="stepThreeMotorImagesPath['frontCenter']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'frontCenter').length > 0" class="mt-3 pl-2">
                                          <div>
                                            <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'frontCenter')[0].message}}</small>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview"  id="_frontLeft" :src="stepThreeMotorImagesPath['frontLeft']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'frontLeft').length > 0" class="mt-3 pl-2">
                                          <div>
                                            <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'frontLeft')[0].message}}</small>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_centerRight" :src="stepThreeMotorImagesPath['centerRight']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'centerRight').length > 0" class="mt-3 pl-2">
                                          <div>
                                            <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'centerRight')[0].message}}</small>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_centerTop" :src="stepThreeMotorImagesPath['centerTop']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'centerTop').length > 0" class="mt-3 pl-2">
                                          <div>
                                            <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'centerTop')[0].message}}</small>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_centerLeft" :src="stepThreeMotorImagesPath['centerLeft']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'centerLeft').length > 0" class="mt-3 pl-2">
                                          <div>
                                            <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'centerLeft')[0].message}}</small>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_rearRight" :src="stepThreeMotorImagesPath['rearRight']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rearRight').length > 0" class="mt-3 pl-2">
                                          <div>
                                            <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rearRight')[0].message}}</small>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_rearCenter" :src="stepThreeMotorImagesPath['rearCenter']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rearCenter').length > 0" class="mt-3 pl-2">
                                          <div>
                                            <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rearCenter')[0].message}}</small>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div class="image-gallery-box">
                                          <img class="img-fluid img-preview" id="_rearLeft" :src="stepThreeMotorImagesPath['rearLeft']" alt="Image Preview">
                                        </div>
                                        <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rearLeft').length > 0" class="mt-3 pl-2">
                                          <div>
                                            <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rearLeft')[0].message}}</small>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-5 order-1 order-md-2 mb-3">
                                  <div class="container mx-auto ib-car-bg">
                                    <div class="row">
                                      <div class="col-4">
                                        <div class="input-btn-width input-first-btn" :content="`Upload Front Right`" v-tippy="{arrow: true}">
                                          <input id="frontRight" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'frontRight')" class="css-checkbox">
                                          <label for="frontRight" class="css-label-checked" v-if="stepThreeMotorImages['frontRight'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="frontRight" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-second-btn" :content="`upload Front Center`" v-tippy="{arrow: true}">
                                          <input id="frontCenter" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'frontCenter')" class="css-checkbox">
                                          <label for="frontCenter" class="css-label-checked" v-if="stepThreeMotorImages['frontCenter'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="frontCenter" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-third-btn" :content="`Upload Front Left`" v-tippy="{arrow: true}">
                                          <input id="frontLeft" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'frontLeft')" class="css-checkbox">
                                          <label for="frontLeft" class="css-label-checked" v-if="stepThreeMotorImages['frontLeft'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="frontLeft" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-4">
                                        <div class="input-btn-width input-forth-btn" :content="`Upload Center Right`" v-tippy="{arrow: true}">
                                          <input id="centerRight" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'centerRight')" class="css-checkbox">
                                          <label for="centerRight" class="css-label-checked" v-if="stepThreeMotorImages['centerRight'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="centerRight" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-fifth-btn" :content="`Upload Center Top`" v-tippy="{arrow: true}">
                                          <input id="centerTop" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'centerTop')" class="css-checkbox">
                                          <label for="centerTop" class="css-label-checked" v-if="stepThreeMotorImages['centerTop'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="centerTop" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-sixth-btn" :content="`Upload Center Left`" v-tippy="{arrow: true}">
                                          <input id="centerLeft" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'centerLeft')" class="css-checkbox">
                                          <label for="centerLeft" class="css-label-checked" v-if="stepThreeMotorImages['centerLeft'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="centerLeft" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-4">
                                        <div class="input-btn-width input-seventh-btn" :content="`Upload Rear Right`" v-tippy="{arrow: true}">
                                          <input id="rearRight" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'rearRight')" class="css-checkbox">
                                          <label for="rearRight" class="css-label-checked" v-if="stepThreeMotorImages['rearRight'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="rearRight" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-eighth-btn" :content="`Upload Rear Center`" v-tippy="{arrow: true}">
                                          <input id="rearCenter" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'rearCenter')" class="css-checkbox">
                                          <label for="rearCenter" class="css-label-checked" v-if="stepThreeMotorImages['rearCenter'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="rearCenter" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <div class="input-btn-width input-ninth-btn" :content="`Upload Rear Left`" v-tippy="{arrow: true}">
                                          <input id="rearLeft" type="file" accept="image/*" name="images[]" @change="uploadStepThreeMotorImages($event, 'rearLeft')" class="css-checkbox">
                                          <label for="rearLeft" class="css-label-checked" v-if="stepThreeMotorImages['rearLeft'].length > 0" style="font-size:20px !important;">&check;</label>
                                          <label for="rearLeft" class="css-label" v-else>&#43;</label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>


                          </form>
                          <div class="col-12 upload-b-container" v-if="nav_step_three">
                            <div class="upload-b-bottom" v-for="(doc_field, up_key) in doc_fields" :key="up_key">
                              <div>
                                <h4 class="ib-upload-heading">{{ doc_field.label}}<span> *</span></h4>
                              </div>
                              <div class="container">

                                <div class="row text-center ib-default-flex" style="justify-content:flex-start !important;">
                                  <div class="d-flex">
                                    <div class="in-flex-box" style="margin-right: 15px;" v-for="(image, key) in files_data[doc_field.field_name]" :key="key" >
                                      <div class="document-list">
                                        <div class="">
                                          <span><img class="doc-remove-icon" v-on:click="removeUploadedFile(image,doc_field.field_name)" :src="require('@/assets/images/ib-upload-remove-icon.svg')" @click="removeStepThreeUploadedImage(index, element.field_name)"></span>
                                        </div>
                                        <span class="document-list-title" style=" border: dashed 2px #3d9cbd;padding: 26px 30px;"><img :src="require('@/assets/images/text-document.svg')"> Document {{ key+1 }}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div key="key1" class="col-2">
                                    <label class="" :for="doc_field.field_name" style="cursor: pointer">
                                      <div class="">
                                        <div class="ib-upload-btn" style="min-width: 11.5rem;" :content="`Upload ${doc_field.field_name.replace(/_/g,' ')}` " v-tippy="{arrow : true}">
                                          <div class="jbl-browse-text"></div>
                                        </div>
                                      </div>
                                    </label>
                                    <input style="display: none"  :name="doc_field.field_name" :id="doc_field.field_name"
                                           type="file"
                                           multiple
                                           accept="image/*"
                                           @change="uploadImage($event,doc_field.field_name)"
                                    />
                                  </div>

                                </div>
                                <div v-if="docFieldsErrors.filter(x => x.field == doc_field.field_name).length > 0" style="text-align: left">
                                    <small class="text-danger" style="bottom: 0;">{{docFieldsErrors.filter(x => x.field == doc_field.field_name)[0].message}}</small>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="mt-5">
                            <button type="button" v-if="nav_step_one == false" v-on:click="update_nav_step_back(nav_step_two ? 1 : 2   )" class="ib-btn-primary ib-btn-width ib-btn-hover ib-btn-outline mr-3">PREVIOUS</button>
                            <button  class="ib-btn-primary ib-btn-hover ib-btn-width" id="main_submit_button" @click.prevent.stop="submitClaim">Next</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

<!--                  <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab" v-if="nav_step_three">-->


<!--                    <div class="mt-5">-->
<!--                      <button v-show="back_btn"  v-on:click="next_step(0)" class="ib-btn-primary ib-btn-width ib-btn-hover ib-btn-outline mr-3">PREVIOUS</button>-->
<!--                      <button class="ib-btn-primary ib-btn-width ib-btn-hover" v-on:click="submit_form_data(1)">CONTINUE</button>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>

              </div>
              <div id="overlay" style="text-align: center" v-show="overlay">
                <div class="ib-finish-container">
                  <div class="ib-finish-top" style="margin-top: 4rem; border-bottom:none !important;">
                    <img class="img-fluid" :src="require('@/assets/images/success.png')">
                    <div class="finish-submitted">
                      Claim Logged Successfully
                    </div>
                    <div class="finish-success">View Submitted claim form in documents</div>
                  </div>
                  <div class="ib-action-btns mb-5">
                    <router-link :to="{ name: 'Claims' }" class="ib-btn-primary ib-btn-width ib-btn-hover mr-3" style="display: inline-block; margin-right: 20px;">FINISH</router-link>
                    <a class="ib-btn-primary ib-btn-width ib-btn-hover" :href="document_link" target="_blank" style="padding-left: 20px;">View&nbsp;Document</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import loading from '@/components/Loading/Loading'
  import moment from "moment";

  export default {
    name: 'AddClaim',
    components: {
      loading
    },
    data() {
      return {
        nav_step_one: true,
        nav_step_two: false,
        nav_step_three: false,
        nav_step_four: false,
        showLoader : false,
        SubStep : false,
        selectedPolicy: [],
        stepZeroDynamicField:[],
        stepZeroErrors:[],
        mainArea : true,
        document_link: '',
        back_btn: false,
        images: [],
        customer_self_claims: {},
        customer_nominated_claims: {},
        customer_claims: {},
        policy_type: true,
        self_policies: false,
        nav_link: 0,
        active: false,
        customer_quotation_id: 0,
        claim_types: {},
        type_id : 0,
        from_info: {},
        form_fields: {},
        doc_fields: {},
        form_name: '',
        files_data: [],
        overlay: false,
        tab_heading: 'Register Claim',
        MajorClass: '',
        Policies: {},
        major_classes: {},
        typeSubmit: false,
        Prev: true,
        tempPre : false,
        TypeArea: false,
        typeform1: true,
        typeSubmitTemp: true,
        typeform2: false,
        stepThreeMotorImages: {
          frontRight: [],
          frontCenter: [],
          frontLeft: [],
          centerRight: [],
          centerTop: [],
          centerLeft: [],
          rearRight: [],
          rearCenter: [],
          rearLeft: [],
        },
        stepThreeMotorImagesPath: {
          frontRight: [],
          frontCenter: [],
          frontLeft: [],
          centerRight: [],
          centerTop: [],
          centerLeft: [],
          rearRight: [],
          rearCenter: [],
          rearLeft: [],
        },
        stepThreeMotorImagesErrors: [],
        docFieldsErrors: [],
        motorWorkflow: {},
        selectedClassId : '',
        j : 0,
        selectedSubclassname : 0,
        MotorCycleImages : [],
        UploadRequiredDocument : false,
        uploadImages : false,
        risk_id: undefined,
        risks: {},
        selected_claim_type: '',
        inspection_images_config: '',
        claimForm: {},
        section_id: undefined,
      };
    },
    created: function () {
      const self = this;
      self.getData();
    },
    methods: {
      setRiskId: function (id){
        this.risk_id = id;
        this.set_quotation_id(this.selectedPolicy.id, this.selectedPolicy.subclass_name,this.selectedPolicy);
      },
      showSubStepOne(){
        const self = this;
        self.typeform2 = !self.typeform2;
        self.setType(self.type_id);
      },
      formatDBDate (dbDate, type) {
        if(dbDate == '' || dbDate == null || dbDate == undefined) {
          return '';
        } else {
          if(type == 'field') {
            var parts = dbDate.split('-'); //'20-04-2021'
            if (parts[2].length == 4){
              var newDate = new Date(parts[2], parts[1] -1, parts[0]);
            }else{
              var newDate = new Date(parts[0], parts[1] -1, parts[2]);
            }
          }
          if(type == 'beneficiary') {
            var parts = dbDate.split('-'); //'2021-04-20'
            if (parts[2].length == 4){
              var newDate = new Date(parts[2], parts[1] -1, parts[0]);
            }else{
              var newDate = new Date(parts[0], parts[1] -1, parts[2]);
            }
          }
          if(type == 'acq'){
            var parts = dbDate.split('-'); //'20-04-2021'
            if (parts[2].length == 4){
              var newDate = new Date(parts[2], parts[1] -1, parts[0]);
            }else{
              var newDate = new Date(parts[0], parts[1] -1, parts[2]);
            }
            return newDate;
          }
          //let newDate = new Date(Date.parse(dbDate));
          let date = newDate.getDate();
          let month = newDate.getMonth() + 1;
          let year = Math.abs(newDate.getFullYear());
          let newDateString = month + '-' + date + '-' + year;
          let selectedDate = moment(newDateString, "M-D-YYYY").toDate();
          return selectedDate;
        }
      },
      formatDate(date) {
        return moment(date, "YYYY-DD-MM").format('DD-MMM-YYYY');
      },
      async getData() {
        const self = this;
        const promises = [];

        self.showLoader = true;
        promises.push(await axios.get('customer/customer_policies_listing?status=active').then(function (resp) {
          if(resp.data.code == 200) {
            self.customer_claims = resp.data.data.policies;
            self.Policies = resp.data.data.policies;
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        }));

        promises.push(await axios.get('get_mainclasses').then(function (resp) {
          if(resp.data.code == 200) {
            self.first_class = resp.data.data.main_classes[0];
            self.major_classes = resp.data.data.main_classes;
            self.MajorClass = self.first_class.name;
            self.selectedClassId = self.first_class.id;


          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        }));

        Promise.all(promises).then(() => {
          self.showLoader = false;
          self.customer_claims = self.Policies.filter(x => x.mainclass_name.toLowerCase() == self.first_class.name.replace(/ /g,"_").toLowerCase());
          if (self.Policies.length === 0) {
            self.customer_claims = {};
            $toast.error('No Policies Found.', { position: 'top-right' });
          }
        });
      },
      ShowNextForm() {
        var self = this;
        self.typeform1 = !self.typeform1;
        if (self.inspection_images_config != undefined && Object.keys(self.inspection_images_config).length > 0){
          self.typeform2 = true;
        }else{
          self.typeform2 = false;
        }

        self.typeSubmit = !self.typeSubmit;
        self.typeSubmitTemp = !self.typeSubmitTemp;
      },
      update_nav_step:  function(key){
        const  self = this;
        self.nav_step_one = false;
        self.nav_step_two = false;
        self.nav_step_three = false;
        self.nav_step_four = false;
          if (key ==1){
            self.nav_step_one = true;

          }
        if (key ==2){
          if (self.inspection_images_config != undefined && Object.keys(self.inspection_images_config).length > 0 && self.uploadImages == 1){
            self.nav_step_two = true;
          }else{
            self.nav_step_three = true;
          }
        }
          if (key ==3){
            self.nav_step_three = true;

          }
          if (key ==4){
            self.nav_step_four = true;

          }
        },
      update_nav_step_back:  function(key){
        const  self = this;
        self.nav_step_one = false;
        self.nav_step_two = false;
        self.nav_step_three = false;
        self.nav_step_four = false;
          if (key ==1){
            self.nav_step_one = true;
          }
          if (key ==2){
            if (self.inspection_images_config != undefined && Object.keys(self.inspection_images_config).length > 0 && self.uploadImages == 1){
              self.nav_step_two = true;
            }else{
              self.nav_step_one = true;
            }
          }
          if (key ==3){
            self.nav_step_three = true;
          }
          if (key ==4){
            self.nav_step_four = true;
          }
        },
      submitClaim: function () {
        const self = this;
        //============================Nav Step 1 START
        self.tab_heading = 'Register Claim';
        if (self.claimForm != undefined || Object.keys(self.claimForm).length == 0){
          self.tab_heading = 'Register Claim';
          self.stepZeroErrors = [];
          Object.entries(this.claimForm).forEach(([key, section]) => {
            Object.entries(section.custom_fields).forEach(([_key, field]) => {
              if(self.stepZeroDynamicField[field.field_name] == ''){
                self.stepZeroErrors.push({
                  field: field.field_name,
                  message:field.field_name.replace(/_/g,' ') + ' required'
                });
              }
            });
          });

          if (self.stepZeroErrors.length > 0){
            self.update_nav_step(1);
            return false;
          }
        }
        //============================Nav Step 1 END

          if (self.nav_step_one === true){
            if (self.inspection_images_config != undefined && Object.keys(self.inspection_images_config).length > 0 && self.uploadImages == 1){
              self.update_nav_step(2);
            }else{
              if (self.doc_fields != undefined && self.doc_fields.length > 0  && self.UploadRequiredDocument) {
                self.update_nav_step(3);
              }else{
                self.update_nav_step(1);
                $toast.error(`Documents not configured.`, { position: 'top-right' });
                return false;
              }
            }
            return false;
          }

        //============================Nav Step 2 START
        if (self.inspection_images_config != undefined && Object.keys(self.inspection_images_config).length > 0 && self.uploadImages == 1){
          self.tab_heading = 'Upload Images';
          self.stepThreeMotorImagesErrors = [];
          let count = 0
          Object.entries(self.stepThreeMotorImages).forEach(([key, field]) => {

            if (field.length > 0){
              count++;
            }
          });
          if (count < self.inspection_images_config[0].min_images){
            $toast.error(`Minimum ${self.inspection_images_config[0].min_images} images required`, { position: 'top-right' });
            self.update_nav_step(2);
            return false;
          }
        }
        // ============================ Nav Step 2 END

        if (self.nav_step_two === true){
          self.update_nav_step(3);
          return false;
        }

        // ============================ Nav Step 3 START
          if (self.doc_fields != undefined && self.doc_fields.length > 0  && self.UploadRequiredDocument){
            self.tab_heading = 'Upload documents';
            self.docFieldsErrors = [];
            Object.entries(self.doc_fields).forEach(([key, value]) => {
              if (self.files_data[value.field_name].length < value.min_rule){
                self.docFieldsErrors.push({
                  field: value.field_name,
                  message: `minimum ${value.min_rule} ${value.field_name} required`
                });
              }
            });

            if (self.docFieldsErrors.length > 0){
              $toast.error(`Please review fields`, { position: 'top-right' });
              self.update_nav_step(3);
              return false;
            }
          }
        // ============================ Nav Step 3 END

        self.submit_form_data();
      },
      async submit_form_data() {
        const self = this;
        self.showLoader = true;
        if (self.selectedSubclassname.toLowerCase().includes('cycle')){
          var formData = new FormData();
          formData.append('images[]', self.MotorCycleImages);
        }else{
          var formData = new FormData(document.getElementById('custom_form'));
        }

        formData.append('section_id', self.section_id);
        formData.append('claim_type_id', self.type_id);
        formData.append('risk_id', self.risk_id);
        formData.append('company_id', self.selectedPolicy.company_id);

          Object.entries(this.claimForm).forEach(([key, section]) => {
            Object.entries(section.custom_fields).forEach(([_key, field]) => {
              formData.append(field.field_name, self.stepZeroDynamicField[field.field_name]);
            });
          });

        if (self.doc_fields != undefined && self.doc_fields.length > 0  && self.uploadImages){
          Object.entries(self.stepThreeMotorImages).forEach(([key, field]) => {
            if (field.length > 0){
              formData.append(`${self.inspection_images_config[0].field_name}[]`, field[0]);
            }
          });
        }
        if (self.doc_fields != undefined && self.doc_fields.length > 0  && self.UploadRequiredDocument) {
          Object.entries(self.doc_fields).forEach(([key, value]) => {
            for (const index in self.files_data[value.field_name]) {
              formData.append(`${value.field_name}[]`, self.files_data[value.field_name][index]);
            }
          });
        }
          await axios.post('customer/claims/create',formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (resp) {
            self.showLoader = false;
            if (resp.data.code == 200) {
              self.document_link = resp.data.data.document_link;
              self.tab_heading = 'Summary';
              self.back_btn = false;
              self.overlay = true;
              self.mainArea = false;
              $toast.success(resp.data.message, {position: 'top-right'});
            } else {
              $toast.error(resp.data.message, { position: 'top-right' });
              return false;
            }
          }).catch(function (error) {
            self.showLoader = false;
            if(error.data.errors != undefined) {
              error.data.errors.forEach(element => {
                $toast.error(element.message, { position: 'top-right' });
              });
            } else {
              $toast.error(error.data.message, { position: 'top-right' });
            }
          });
      },
      removeUploadedFile(index, fieldName) {
        const self = this;
        self.files_data[fieldName].splice(index, 1);
        self.files_data.push({ test: 'test' });
        self.files_data.splice(-1, 1);
      },
      uploadImage(e, field_name) {
        const self = this;
        self.docFieldsErrors = [];
        Object.entries(self.doc_fields).forEach(([key, value]) => {
          if (self.files_data[value.field_name].length >= value.max_rule){
            self.docFieldsErrors.push({
              field: value.field_name,
              message: `maximum ${value.max_rule} ${value.field_name} allowed`
            });
          }
        });

        if (self.docFieldsErrors.length > 0){
          return false;
        }

        var selectedFiles = e.target.files;
        for (let i = 0; i < selectedFiles.length; i++) {
          self.files_data[field_name].push(selectedFiles[i]);
        }
        self.$forceUpdate();
        self.files_data.push({ test: 'test' });
        self.files_data.splice(-1, 1);
      },
      containsKey (obj, key ) {
        return Object.keys(obj).includes(key);
      },
      LoadClaims(class_name) {
        const self = this;
        self.MajorClass = class_name.name;
        self.selectedClassId = class_name.id;
        self.claim_types = {};
        self.customer_claims = self.Policies.filter(x => x.mainclass_name.toLowerCase() == class_name.name.replace(/ /g,"_").toLowerCase());
      },
      removestepThreeMotorImages (index){
        const self = this;
        self.MotorCycleImages.splice(index, 1);
      },
      uploadStepThreeMotorImages (e, field_name = 0) {
        let self = this;
        if(e.target.files.length > 0) {
          var selectedFiles = e.target.files;
        } else {
          return false;
        }
        self.stepTwoDocumentsErrors = [];
        if (self.selectedSubclassname.toLowerCase().includes('cycle')){
          self.MotorCycleImages.push(selectedFiles[0]);
        }else {

          let count = 0
          Object.entries(self.stepThreeMotorImages).forEach(([key, field]) => {

            if (field.length > 0){
              count++;
            }
          });
          if (count >= self.inspection_images_config[0].max_images){
            $toast.error(`Maximum ${self.inspection_images_config[0].max_images} images allowed`, { position: 'top-right' });
            return false;
          }

          if(selectedFiles[0]['type'].split('/')[0] != 'image') {
            $toast.error('Only image files are accepted', { position: 'top-right' });
          } else if (selectedFiles[0].size > 5000000) {
            $toast.error('Upload file less than 5Mb', { position: 'top-right' });
            return false;
          } else {
            self.stepThreeMotorImages[field_name] = [];
            self.stepThreeMotorImages[field_name].push(selectedFiles[0]);
            const file = e.target.files[0];
            var url = URL.createObjectURL(file);
            $('#_'+field_name).attr('src', url);
            self.stepThreeMotorImagesPath[field_name].push(url);
          }
        }

      },
      isDisable(data) {
        if (data.length == undefined) {
          return true;
        } else {
          return data.length < 0;
        }
      },
      // validateMotorImages(e) {
      //   const self = this;
      //   if (self.j == 0){
      //     if (self.files_data.length <= 0){
      //       $toast.error('Document Not Configured Against This Type', { position: 'top-right' });
      //       return  false;
      //     }else{
      //       self.next_step(1, 'Upload Document');
      //     }
      //   }else{
      //     if (self.selectedSubclassname.toLowerCase().includes('cycle')){
      //         if (self.MotorCycleImages.length <= 0){
      //           $toast.error('Please Select at least 1 Image', { position: 'top-right' });
      //           return false;
      //         }else{
      //           if (self.files_data.length <= 0){
      //             $toast.error('Document Not Configured Against This Type', { position: 'top-right' });
      //             return  false;
      //           }else{
      //             self.next_step(1, 'Upload Document');
      //           }
      //         }
      //     }else{
      //       self.stepThreeMotorImagesErrors = [];
      //       Object.entries(self.stepThreeMotorImages).forEach(([key, field]) => {
      //         if(field.length <= 0) {
      //           self.stepThreeMotorImagesErrors.push({
      //             field: key,
      //             message: key.replace(/_/g,' ') + ' required'
      //           });
      //         }
      //       });
      //
      //       if (self.stepThreeMotorImagesErrors.length > 0) {
      //         return false;
      //       } else {
      //         if (self.files_data.length <= 0){
      //           $toast.error('Document Not Configured Against This Type', { position: 'top-right' });
      //           return  false;
      //         }else{
      //           self.next_step(1, 'Upload Document');
      //         }
      //       }
      //     }
      //
      //   }
      //
      // },
      submitClaimForm: function (e) {
        const self = this;
        e.preventDefault();

        if (self.j == 0){
          if (self.UploadRequiredDocument == 1){
            self.next_step(1, 'Upload Document');
          }else{
            self.submit_form_data();
          }
        }else{
          if (self.selectedSubclassname.toLowerCase().includes('cycle')){
            if (self.MotorCycleImages.length <= 0){
              $toast.error('Please Select at least 1 Image', { position: 'top-right' });
              return false;
            }else{
              if (self.files_data.length <= 0){
                $toast.error('Document Not Configured Against This Type', { position: 'top-right' });
                return  false;
              }else{
                if (self.UploadRequiredDocument == 1){
                  self.next_step(1, 'Upload Document');
                }else{
                  self.submit_form_data();
                }
              }
            }
          }else{
            self.stepThreeMotorImagesErrors = [];
            Object.entries(self.stepThreeMotorImages).forEach(([key, field]) => {
              if (self.type_id != 1){
                if((key == 'frontRight' || key == 'frontLeft' || key == 'rearLeft' || key == 'rearRight') && field.length <= 0) {
                  self.stepThreeMotorImagesErrors.push({
                    field: key,
                    message: key.replace(/_/g,' ') + ' required'
                  });
                }
              }
            });
            if (self.stepThreeMotorImagesErrors.length > 0) {
              return false;
            } else {
              if (self.UploadRequiredDocument == 1){
                self.next_step(1, 'Upload Document');
              }else{
                self.submit_form_data();
              }
            }
          }

        }
      },

      async setType(type_id) {
        const self = this;
        self.showLoader = true;
        self.type_id = type_id;
        self.typeSubmit = false;
        self.Prev = true;
        self.tempPre = false;
        // self.TypeArea = false;
        self.typeform1 = true;
        self.typeSubmitTemp = true;
        self.typeform2 = false;
        self.selected_claim_type = type_id;

        await axios.post('customer/customer_claim_fields',{ claim_type_id : self.type_id, customer_quotation_id : self.customer_quotation_id }).then(async function (resp) {
          self.showLoader = false;

          if (resp.data.code == 200) {
            if (resp.data.data.claim_forms == undefined || Object.keys(resp.data.data.claim_forms).length == 0) {

              self.typeSubmitTemp = false;
              self.form_fields = {};
              self.form_name = '';
              $toast.error('Claim Form Fields Not Found', {position: 'top-right'});
              self.showLoader = true;
            } else {
              self.typeSubmitTemp = true;
              self.form_name = Object.keys(resp.data.data.claim_forms)[0];
              self.claimForm = resp.data.data.claim_forms;


              self.doc_fields = resp.data.data.documents;
              self.inspection_images_config = resp.data.data.inspection_images;
              Object.entries(self.doc_fields).forEach(([value, index]) => {
                self.files_data[index.field_name] = [];
              });
              await self.configureWorkflows(resp.data.data.workflows);
              await self.initializeClaimForm();
            }

            // let j = 0;
            // $.each(resp.data.data.workflows.Claims, function (key, value) {
            //   if (key == 'Claims Intimation') {
            //     $.each(value, function (_key, _value) {
            //       if (_value.key == 'upload-images' && _value.customer_app == 1 && self.inspection_images_config != undefined && Object.keys(self.inspection_images_config).length > 0) {
            //         j = 1;
            //         self.j = 1;
            //         // self.typeSubmit = true;
            //         // self.typeform2 = true;
            //         // self.typeSubmitTemp = false;
            //         // self.typeform1 = true;
            //       }
            //       if (_value.key == 'upload-required-document' && _value.customer_app == 1) {
            //         self.UploadRequiredDocument = 1;
            //         // self.typeSubmit = true;
            //         // self.typeform2 = false;
            //         // self.typeSubmitTemp = false;
            //         // self.typeform1 = true;
            //       }
            //     });
            //   }
            // });
            // if (j == 0) {
            //   self.typeSubmit = true;
            //   self.typeform2 = false;
            //   self.typeSubmitTemp = false;
            //   self.typeform1 = true;
            // }
            // self.from_info = resp.data.data.claim_forms;
          } else {
            $toast.error(resp.data.message, {position: 'top-right'});
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      configureWorkflows: async function (Workflows){
        const self = this;
        self.uploadImages = false;
        self.UploadRequiredDocument = false;

        $.each(Workflows.Claims, function (key, value) {
          if (key == 'Claims Intimation') {
            $.each(value, function (_key, _value) {
              if (_value.key == 'upload-images' && _value.customer_app == 1 && self.inspection_images_config != undefined && Object.keys(self.inspection_images_config).length > 0) {
                  self.uploadImages = true;
              }
              if (_value.key == 'upload-required-document' && _value.customer_app == 1) {
                self.UploadRequiredDocument = true;
              }
            });
          }
        });
      },
      async initializeClaimForm(){
        this.stepZeroDynamicField = [];
        Object.entries(this.claimForm).forEach(([key, section]) => {
          Object.entries(section.custom_fields).forEach(([_key, field]) => {
            this.section_id = field.section_id;
            this.stepZeroDynamicField[field.field_name] = '';
          });
        });
      },
      show_policies: function (event) {
        const self = this;
        self.policy_type = !self.policy_type;
        self.self_policies = !self.self_policies;
      },
      next_step: function (event, heading = 'Register Claim') {
        const self = this;
        self.tab_heading = heading;
        var obj = document.getElementsByClassName('nav-link-local');
        var tab = document.getElementsByClassName('tab-pane');
        obj[self.nav_link].classList.remove("active");
        tab[self.nav_link].classList.remove("active", "show");
        self.policy_type = true;
        self.self_policies = false;
        self.back_btn = true;
        if (event == 1) {
          if (self.nav_link + 1 == 100) {
            document.getElementById('step_2').style.display = 'none';
            document.getElementById('step_2_hover').style.display = 'block';
          } else if(self.nav_link + 1 == 1) {
            self.setType(self.claim_types[0].id);
            self.TypeArea = !self.TypeArea;
            document.getElementById('step_3').style.display = 'none';
            document.getElementById('step_3_hover').style.display = 'block';
          } else if(self.nav_link + 1 == 2) {
            document.getElementById('step_4').style.display = 'none';
            document.getElementById('step_4_hover').style.display = 'block';
          } else if(self.nav_link + 1 == 3) {
            document.getElementById('step_5').style.display = 'none';
            document.getElementById('step_5_hover').style.display = 'block';
          }
          obj[self.nav_link+1].classList.add("active");
          tab[self.nav_link+1].classList.add("active", "show");
          self.nav_link = self.nav_link + 1;
        } else {
          if (self.nav_link == 1) {
            document.getElementById('step_1').style.display = 'block';
            document.getElementById('step_1_hover').style.display = 'none';
          } else if(self.nav_link == 2) {
            document.getElementById('step_3').style.display = 'block';
            document.getElementById('step_3_hover').style.display = 'none';
          } else if(self.nav_link == 3) {
            document.getElementById('step_4').style.display = 'block';
            document.getElementById('step_4_hover').style.display = 'none';
          } else if(self.nav_link == 4) {
            document.getElementById('step_5').style.display = 'block';
            document.getElementById('step_5_hover').style.display = 'none';
          }
          obj[self.nav_link-1].classList.add("active");
          tab[self.nav_link-1].classList.add("active", "show");
          self.nav_link = self.nav_link - 1;
        }
        if (self.nav_link == 0) {
          self.back_btn = false;
          self.show_policies();
        }
      },
      async set_quotation_id(customer_quotation_id, subclass_name, policy) {
        const self = this;
        self.selectedPolicy = policy;
        self.risk_id = undefined;
        if (policy.risks_count <= 1){
          self.risk_id = policy.risk_id;
        }
        if (self.risk_id == undefined){
          await axios.get('customer/risks_listing?form_data=1&customer_quotation_id=' + customer_quotation_id).then(function (resp) {
            self.showLoader = false;
            if (resp.data.code == 200) {
              self.risks = resp.data.risks;
              self.SubStep = true;
            } else {
              $toast.error(resp.data.message, { position: 'top-right' });
              return false;
            }
          }).catch(function (error) {
            self.showLoader = false;
            if(error.data.errors != undefined) {
              error.data.errors.forEach(element => {
                $toast.error(element.message, { position: 'top-right' });
              });
            } else {
              $toast.error(error.data.message, { position: 'top-right' });
            }
          });
          return false;
        }
        self.showLoader = true;
        self.customer_quotation_id = customer_quotation_id;
        self.selectedSubclassname = subclass_name;
        await axios.get('customer/claim_types?customer_quotation_id=' + customer_quotation_id ).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.claim_types = resp.data.data;
            if (self.claim_types.length === 0) {
              $toast.error('No Type Found Against This Policy', {position: 'top-right'});
            } else {
              self.next_step(1);
              self.nav_step_one = true;
            }
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      complete_form() {
        var self = this;
        self.overlay = true;
      }
    }
  };
  </script>


  <style scoped>
  .text-danger{
    margin-top: 2px;
    float: left;
  }
  .data-row p {
    color :#5b6770;
  }
  table > tbody > tr, .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  /* table > tbody > tr > th > img,.data-img img {
    width: 79px;
    height: 66px;
    border-radius: 11px;
    border: 1px solid gainsboro;
  }
  .position-relative .small-icon {
    border-radius: 50%;
    position: absolute;
    width: 25px;
    height: 25px;
    top: -20px;
    right: 0px;
  } */
  .in-listing-img {
    width: 79px;
    height: 66px;
    background-color: #ecf3f5;
    border-radius: 11px;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .in-listing-img img{
    width: 100% !important;
    max-width: 70px !important;
    max-height: 60px !important;
    height: auto !important;
  }

  .position-relative-box {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: absolute;
    bottom: -10px;
    right: -10px;
  }
  .position-relative-box img{
    width: 100% !important;
    max-width: 23px !important;
    height: auto !important;
  }
  table.claim-listing {
    width: 100%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    border-spacing: 0 10px;
  }
  table.claim-listing td {
    height: 100px !important;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
  @media (max-width:668px) {
    table.claim-listing td:not(:first-child) {
      height: 60px !important;
    }
    table.claim-listing tbody td:first-child {
      height: auto !important;
    }
  }
  table.claim-listing td:last-child:after {
    content: none;
  }
  table.claim-listing tbody td {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  @media (min-width:669px) {
    table.claim-listing tbody td:first-child {
      border-left: 1px solid #eee;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    table.claim-listing tbody td:last-child {
      border-right: 1px solid #eee;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    table.claim-listing tbody tr {
      box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    }
  }
  .jbl-table-heading {
    font-family: "Avenir Medium";
    font-weight: 500;
    text-align: left !important;
    font-size: 19px;
    color: #5b6770;
  }
  /* .jbl-table-heading span {
    font-size: 19px;
    font-size: 10px;
    color: #5b6770;
    font-weight: normal !important;
  } */
  .jbl-table-heading span {
    font-weight: normal !important;
    font-size: 10px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-table-heading small {
    font-weight: normal !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-date-td {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
  }
  .jbl-date-heading {
    color: #ef7c94 !important;
    font-family: "Avenir Book";
    font-size: 13px;
    text-align: left;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 2rem;
    color: #5b6770;
  }
  .jbl-flex-td {
    display: flex;
    flex-direction: column;
  }
  @media (min-width:668px) and (max-width:992px) {
    .jbl-table-heading {
      font-size: 14px;
    }
    .jbl-date-td {
      font-family:"Futura PT Medium";
      font-size: 12px;
    }
    table.claim-listing .fa-chevron-right {
      padding-right: 1rem;
      color: #5b6770;
    }
  }
  .d2c-main-classes {
    background-color: #def3f7;
    border-radius: 31px;
    max-width: fit-content;
    margin: 1px 0 30px;
  }
  .d2c-class-btn {
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
    padding: 6px 12px;
    border: 1px solid transparent;
    border-radius: 4px;
    height: 61px;
    margin: 0 0 1px;
    border-radius: 31px;
    background-color: #def3f7;
    font-family: "Avenir Medium";
    font-size: 16px;
    font-weight: 500;
    line-height: 1.38;
    color: #4c505d;
    transition: all .3s ease-in;
  }
  .d2c-class-btn:hover {
    background-color: #049cbd;
    color: white;
  }
  .d2c-class-btn:focus, .d2c-class-btn:active, .d2c-class-btn.active {
    outline: none !important;
    background-color: #049cbd;
    color: white;
  }
  /* .d2c-main-classes .d2c-class-btn::after {
    content: '';
    width: 0;
    height: 35px;
    border: solid 1px #049ab3;
    position: relative;
    right: -16px;
  }
  .d2c-main-classes.d2c-class-tabs button.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .d2c-main-classes button:last-child.d2c-class-btn::after {
    content: '';
    border: none !important;
  } */
  .nex-Page-Link .fa-chevron-right {
    color: #aeccd6 !important;
    font-weight: normal !important;
  }
  @media(max-width:550px){
    .d2c-class-btn{
      padding: 6px 22px !important;
      width: max-content !important;
      font-size: 12px !important;
    }
  }
  .multistep-box label:not(.css-label,.css-label-checked) {
    display: block !important;
    text-align: left !important;
  }
  .class-name {
    font-size: 13px !important;
  }
  .d2c-class-container .class-box {
    width: 8.5rem !important;
    height: 8.5rem !important;

  }
  </style>



// WEBPACK FOOTER //
// src/views/Claims/AddClaim.vue